import { render, staticRenderFns } from "./TwoColImageTextSection.vue?vue&type=template&id=454efad2&"
import script from "./TwoColImageTextSection.vue?vue&type=script&lang=js&"
export * from "./TwoColImageTextSection.vue?vue&type=script&lang=js&"
import style0 from "./TwoColImageTextSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports